export function ShopCardGridSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div key={i} className="rounded-2xl bg-surface-raised shadow-card overflow-hidden">
          <div className="h-40 bg-surface-muted animate-pulse" />
          <div className="p-5 space-y-3">
            <div className="h-5 w-1/3 bg-surface-muted rounded animate-pulse" />
            <div className="h-4 w-full bg-surface-muted rounded animate-pulse" />
            <div className="h-4 w-2/3 bg-surface-muted rounded animate-pulse" />
            <div className="h-10 bg-surface-muted rounded-xl animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ShopCardListSkeleton() {
  return (
    <div className="space-y-4">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="rounded-2xl bg-surface-raised shadow-card p-6 flex gap-6">
          <div className="w-40 h-28 rounded-xl bg-surface-muted animate-pulse shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-5 w-1/4 bg-surface-muted rounded animate-pulse" />
            <div className="h-4 w-full bg-surface-muted rounded animate-pulse" />
            <div className="h-9 w-24 bg-surface-muted rounded-xl animate-pulse mt-4" />
          </div>
        </div>
      ))}
    </div>
  );
}
